import React from 'react';
import StartupDetail from './StartupDetail';

/**
 * Startup detail for INVESTOR and INVESTOR_NETWORK routes: portfolio context, read-only company/team,
 * with investments/tranches where the user has network permissions. Uses StartupDetail with
 * accessScope portfolio (no director mutations, investor-appropriate data loading).
 */
const PortfolioStartupDetail = () => {
	return <StartupDetail accessScope="portfolio" />;
};

export default PortfolioStartupDetail;
